var $ = require('jquery');
require('webpack-jquery-ui/selectmenu');
import 'magnific-popup';


$(function () {
	teamFilter();
	initPopups();
});

function teamFilter() {
	$('.team-members__triggers a').on('click', function (e) {
		e.preventDefault();
		var cat = $(this).data('cat');

		$('.team-members__triggers__item').removeClass('active');
		$(this).addClass('active');
		$('.team-members__members > a').fadeOut(1);
		$('.team-members__members ' + cat).fadeIn(200);
	});

	$('.team-members__select').selectmenu({
		open: function () {
			const uuid = $(this).attr('id')
			const selectButtonId = `${uuid}-button`;
			const dropdownId = `${uuid}-menu`

			$(`#${dropdownId}`).width($(`#${selectButtonId}`).outerWidth()-2)
			
			if (!$('.ui-menu .ui-menu-item').hasClass('active'))
				$('.ui-menu .ui-menu-item:first-child').addClass('active');
		},
		change: function (event, ui) {
			var cat = $(this).val();
			$(this).siblings().removeClass('active');
			$('.team-members__members > a').fadeOut(1);
			$('.team-members__members ' + cat).fadeIn(200);
			const menuId = $(this).attr('id') + '-menu'
			$(`#${menuId} .ui-menu-item`).removeClass('active');
			$(`#${menuId} .ui-menu-item:nth-child(${parseInt(ui.item.index) + 1})`).addClass('active')
			if ($(`#${menuId} .ui-menu-item:last-child`).hasClass('active')) {
				$(`#${menuId} .ui-menu-item:nth-last-child(2)`).addClass('border-none');
			} else {
				$(`#${menuId} .ui-menu-item`).removeClass('border-none')
			}
		}
	});

	/*## For members without profile picture - Get biggest element HEIGHT and assign to all with the same class ##*/
	var maxHeight = 0;
	$('.without-image').each(function () {
		var thisH = $(this).height();
		if (thisH > maxHeight) { maxHeight = thisH; }
	});
	$('.without-image').height(maxHeight);

}


function initPopups() {
	jQuery('.open-popup-team:not(.click-disabled)').magnificPopup({
		type: 'inline',
		midClick: true,
		removalDelay: 300,
		closeOnBgClick: true,
		mainClass: 'mfp-fade',
		showCloseBtn: false,
		closeBtnInside: false,
		callbacks: {
			open: function () {
				$('body,html').addClass('noscroll');
				location.href = location.href.split('#')[0] + "#lightbox";
			},
			close: function () {
				$('body,html').removeClass('noscroll');
				if (location.hash) history.go(-1);
			}
		}
	});
	$('.section-team-members__popup__close').on('click', function (e) {
		e.preventDefault();
		$.magnificPopup.close()
	})
}


$(window).on('hashchange', function () {
	if (location.href.indexOf("#lightbox") < 0) {
		$.magnificPopup.close();
	}
});
